import { randomId } from '@mantine/hooks';
import { assign } from 'lodash';
import { ResourceType } from '../../../../../../resource/enumerations/ResourceType';
import VersionService from '../../../VersionService';
import { ActivityReferenceCreatorFunction } from '../ActivityReferenceCreatorDialog';

const functionImageSvg =
    '<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-sitemap"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 15m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" /><path d="M15 15m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" /><path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" /><path d="M6 15v-1a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v1" /><path d="M12 9l0 3" /></svg>';
const editSvg =
    '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" \n' +
    '\t viewBox="0 0 32 32" enable-background="new 0 0 32 32" xml:space="preserve">\n' +
    '<path fill="none" stroke="#000000" stroke-width="2" stroke-miterlimit="10" d="M22.3,6.5l0.8-0.8c0.9-0.9,2.3-0.9,3.2,0l0,0\n' +
    '\tc0.9,0.9,0.9,2.3,0,3.2l-0.8,0.8"/>\n' +
    '<line fill="none" stroke="#000000" stroke-width="2" stroke-miterlimit="10" x1="18.9" y1="8.8" x2="23.2" y2="13.1"/>\n' +
    '<polyline fill="none" stroke="#000000" stroke-width="2" stroke-miterlimit="10" points="10.8,25.6 10,22 6.4,21.2 "/>\n' +
    '<path fill="none" stroke="#000000" stroke-width="2" stroke-miterlimit="10" d="M10.5,25.9L5,27l1.1-5.5L21.7,5.9l4.4,4.4L10.5,25.9\n' +
    '\tz"/>\n' +
    '<path d="M8.5,26.3L5,27l0.7-3.5L8.5,26.3z"/>\n' +
    '</svg>';

/**
 * @param {any} contextPad
 * @param {any} create
 * @param {any} elementFactory
 * @param {any} translate
 * @param {any} config
 * @param {any} injector
 * @param {any} eventBus
 * @param {any} modeling
 * @param {any} connect
 * @param {any} popupMenu
 * @param {any} canvas
 * @param {any} rules
 * @param {any} appendPreview
 * @param {any} moddle
 * @param {any} bpmnReplace
 * @param {VersionService} versionService
 */
export function ActivityReferencePadProvider(
    config,
    injector,
    eventBus,
    contextPad,
    modeling,
    moddle,
    bpmnReplace,
    elementFactory,
    connect,
    create,
    popupMenu,
    canvas,
    rules,
    translate,
    appendPreview,
    versionService
) {
    config = config || {};

    this._contextPad = contextPad;

    this._modeling = modeling;
    this._moddle = moddle;
    this._bpmnReplace = bpmnReplace;

    this._elementFactory = elementFactory;
    this._connect = connect;
    this._create = create;
    this._popupMenu = popupMenu;
    this._canvas = canvas;
    this._rules = rules;
    this._translate = translate;
    this._eventBus = eventBus;
    this._appendPreview = appendPreview;
    this.versionService = versionService;

    contextPad.registerProvider(this);

    if (config.autoPlace !== false) {
        this._autoPlace = injector.get('autoPlace', false);
    }
}

ActivityReferencePadProvider.$inject = [
    'config.contextPad',
    'injector',
    'eventBus',
    'contextPad',
    'modeling',
    'moddle',
    'bpmnReplace',
    'elementFactory',
    'connect',
    'create',
    'popupMenu',
    'canvas',
    'rules',
    'translate',
    'appendPreview',
    'versionService',
];

ActivityReferencePadProvider.prototype.getContextPadEntries = function (/** @type {any} */ element) {
    const entries = this._createPopupAction([element]);
    if (!element.id.includes('Activities_Reference_')) {
        return {
            'append.create-activities-reference': entries['append.create-activities-reference'],
        };
    }

    return entries;
};

ActivityReferencePadProvider.prototype.getMultiElementContextPadEntries = function (/** @type {any} */ elements) {
    return this._createPopupAction(elements);
};

ActivityReferencePadProvider.prototype._createPopupAction = function (/** @type {any} */ elements) {
    const translate = this._translate;
    const contextPad = this._contextPad;
    const popupMenu = this._popupMenu;
    const elementFactory = this._elementFactory;
    const bpmnReplace = this._bpmnReplace;
    const create = this._create;
    const autoPlace = this._autoPlace;
    const appendPreview = this._appendPreview;
    const moddle = this._moddle;
    const modeling = this._modeling;
    const versionService = this.versionService;

    /**
     * Create an append action.
     *
     * @return {any}
     */
    function appendAction() {
        // @ts-expect-error
        const versionId = versionService.getVersionId();

        const append = function (/** @type {any} */ _, /** @type {any} */ element) {
            const id1 = randomId().replace('mantine-', '').slice(0, 4);
            const id2 = randomId().replace('mantine-', '').slice(0, 4);
            ActivityReferenceCreatorFunction(versionId, (objectId) => {
                const businessObject = moddle.create('bpmn:Task');
                businessObject.id = `Activities_Reference_${id1}`;
                businessObject.objectId = objectId;
                businessObject.resourceType = ResourceType.ACTIVITIES;
                const shape = elementFactory.createShape(
                    assign({
                        id: `Activities_Reference_${id2}`,
                        width: 150,
                        height: 130,
                        type: 'bpmn:Task',
                        businessObject,
                    })
                );
                autoPlace.append(element, shape);
            });
        };

        return {
            group: 'activity',
            html: `<div class="entry">${functionImageSvg}</div>`,
            title: translate('Add Activities reference block'),
            action: {
                click: append,
            },
        };
    }

    function editFunctionReference() {
        // @ts-expect-error
        const versionId = versionService.getVersionId();

        return function (/** @type {any} */ event, /** @type {any} */ element) {
            ActivityReferenceCreatorFunction(versionId, (objectId) => {
                modeling.updateProperties(element, {
                    objectId,
                });
            });
        };
    }

    return {
        'append.create-activities-reference': appendAction(),
        'edit-activities-block': {
            group: 'edit',
            html: `<div class="entry">${editSvg}</div>`,
            title: translate('Edit Activity reference block'),
            action: {
                click: editFunctionReference(),
            },
        },
    };
};
